import { useParams } from 'react-router';

import { ROLE_ENUM } from '@/const/role';
import { useUser } from '@/lib/auth';
import { useTenantStore } from '@/stores/tenant-store';

export const useTenant = () => {
  console.info('use-tenant.ts_1');

  const tenantSlug = useParams().tenantSlug;
  const user = useUser();
  const { tenantId, setTenantId } = useTenantStore((state) => ({
    tenantId: state.tenantId,
    setTenantId: state.setTenantId,
  }));

  if (!user.data) {
    console.info('use-tenant.ts_2');
    return { tenantSlug };
  }
  console.info('use-tenant.ts_3');

  const resolvedTenantId =
    user.data.role_id === ROLE_ENUM.ADMIN ? tenantId : user.data.tenant_id;

  return { tenantId: resolvedTenantId, tenantSlug, setTenantId };
};
